<template>
  <div class="row mx-0 rounded mb-2" style="overflow:hidden">
    <router-link :to="{name:'Product', params:{id: product.id}}" class="col-2 p-0 rounded d-none d-lg-block mr-2">
      <img :src="product.img[product.defaultImg]" class="img-fluid rounded">
    </router-link>
    <div class="col-12 col-lg my-auto px-0">
      <router-link :to="{name:'Product', params:{id: product.id}}" class="h5 nav-link fw-bold p-0 active">
        {{product.prices[product.pack].quantity}} - {{product.name}}
      </router-link>
    </div>
    <div class="col my-auto p-0">
      <div class="input-group my-auto">
        <button class="btn btn-outline-danger" type="button" @click="removeToCart">-</button>
        <p class="form-control m-0 text-center px-0"><span class="d-none d-lg-block">Cantidad:</span> <span class="fw-bold">{{product.quantity}}</span></p>
        <button class="btn btn-outline-success" type="button" @click="addToCart">+</button>
      </div>
    </div>
    <div class="col my-auto text-center p-0">
      ${{ price() }}
    </div>
    <div class="col-lg-1 col-2 my-auto p-0">
      <button class="btn" @click="removeFromCart">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <hr class="mt-2 my-0">
  </div>
</template>

<script>
export default {
    name: 'CartProduct',
    props: ['product'],
    methods:{
      addToCart(){
        this.$emit('addToCart', this.product.id, this.product.pack, 1);
      },
      removeToCart(){
        this.$emit('addToCart', this.product.id, this.product.pack, -1);
      },
      removeFromCart(){
        this.$emit('removeFromCart', this.product.id, this.product.pack);
      },
      price(){
        let quantity = this.product.quantity;
        let price = this.product.prices[this.product.pack].price
        return quantity * price
      }
    }
}
</script>

<style>

</style>